import React from 'react';
import {
  SPLIT_SEPARATORS,
  Action,
  withInject,
} from '@piwikpro/platform';
import { FormValidator } from '@piwikpro/form-crate';
import { Card, withTranslation } from '@piwikpro/ui-components';
import { TrackerSettings } from '../../../TrackerSettings';

export interface CampaignIdParamsProps {
  globalAndAppTrackerSettings: Array<string | object>
  trackerSettings: TrackerSettings
  t: (key: string) => string
  validation: FormValidator
  appId: string
}

class CampaignIdParams extends React.Component<CampaignIdParamsProps> {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }) {
    const {
      trackerSettings,
      appId,
      globalAndAppTrackerSettings,
    } = this.props;
    const field = Object.keys(values)[0];
    const valuesWithoutGlobals = {
      [field]: values[field].filter(element => !element.disabled),
    };

    try {
      await trackerSettings.updateSettingsForApp(appId, valuesWithoutGlobals);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        field,
        globalAndAppTrackerSettings,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const {
      globalAndAppTrackerSettings,
      validation,
      t,
    } = this.props;

    return (
      <Card.Section>
        <Action.AutoSavedTagsInputControl
          id="app-settings-campaign-id-params"
          label={t('apps.details.settings.campaignIdParams.title')}
          info={t('components:tagsInput.placeholder.default')}
          name="campaign_id_params"
          initialValue={globalAndAppTrackerSettings}
          validationSchema={validation.createValidationSchema(validators => ({
            campaign_id_params: validators.trackerSettings.campaignIdParams,
          }))}
          splitSeparators={SPLIT_SEPARATORS}
          onSubmit={this.handleSubmit}
        />
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(
  withTranslation(['administration'])(CampaignIdParams as any),
);
